import { DbService } from './db.service';
import { ModalController, Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { LoadingService } from './load.service';
import { HeartService } from './heart.service';
import { AlertService } from 'src/app/services/alert.service';
import { PlatformchkService } from '../services/platformchk.service';

@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  // 프리미엄 결제 진행시에 상태처리
  private orderState: boolean = false;
  // 인앱 결제 진행시에 활서화 처리를 하기 위한 스위치
  private purchaseSwitch: boolean = false;
  // 인앱 결제 금액
  private price: number = 0;

  constructor(
    private db: DbService,
    private platform: Platform,
    public httpc: HttpClient,
    public modalController: ModalController,
    private loading: LoadingService,
    private heartService: HeartService,
    private alert: AlertService,
  ) {}

  get getState(): boolean {
    return this.orderState;
  }
  set setState(state: boolean) {
    this.orderState = state;
  }

  get getPurchaseState(): boolean {
    return this.purchaseSwitch;
  }
  set setPurchaseState(state: boolean) {
    this.purchaseSwitch = state;
  }

  get getPrice(): number {
    return this.price;
  }
  set setPrice(price: number) {
    this.price = price;
  }

  async paymentSuccess(products) {
    const userId: string = localStorage.getItem('userId') ?? '';
    const user = await this.db.doc$(`user/${userId}`).pipe(take(1)).toPromise();
    const type = user.userType != 'celeb' ? user.userType : user.companyType == 'celebCompany' ? 'celebCompany' : 'celeb';
    const product = products[0];
    // 충전 가격은 (price)
    // 핸드폰 기종에 따라!
    const chargePrice: number = this.price;
    let heartNumber: number = 0;
    switch (product.id) {
      case 'neverland.heart40':
        heartNumber = 40;
        break;
      case 'neverland.heart200':
        heartNumber = 200;
        break;
      case 'neverland.heart500':
        heartNumber = 500;
        break;
      case 'neverland.heart700':
        heartNumber = 700;
        break;
      case 'neverland.heart900':
        heartNumber = 900;
        break;
      case 'neverland.heart4100':
        heartNumber = 4100;
        break;
    }

    const chargeHeart = await this.heartService.addHeart(userId, type, chargePrice, heartNumber);
    // this.modalController.dismiss(heartNumber);
    if (chargeHeart == 'success') {
      this.alert.toast('결제를 완료하였습니다.');
    }
  }
}
